<!-- 限销策略分组 -->
<template>
	<div class='page_content'>
		<subComponents  ref="showSelectData"></subComponents>
		<restrictionStrategyGroupAction  ref="restrictionStrategyGroupAction"></restrictionStrategyGroupAction>
		<div class="page_content_top">
			<div class="page_content_top_line">
				<el-button type="primary"  size="mini" @click="actionSet(buttonValue)" v-for="(buttonValue,buttonKey) in buttonList" :key="buttonKey">
					{{buttonValue.jurName}}
				</el-button>
				<el-button type="primary" icon="el-icon-refresh"  size="mini" @click="getDataList()" >
					刷新
				</el-button>
			</div>
			<div class="page_content_top_line">
				<el-form :inline="true" :model="getRequestData" class="demo-form-inline" size="mini">
					<el-form-item label="限销策略分组名称">
						<el-input   v-model.trim="getRequestData.sgvgName"  :maxlength="$store.state.inputLength"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary"  size="mini" @click="searchData">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="page_content_center">
			<el-table   stripe  :data="returnData.list"  height="100%" border style="width: 100%" highlight-current-row>
				<el-table-column   label="数据选择" width="82">
					<template  slot-scope="scope">
						<el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
							<i class="el-icon-thumb"></i>
						</el-radio>
					</template>
				</el-table-column>
				<el-table-column type="expand" label="客户分组"  width="100">
				    <template slot-scope="props">
						<el-table :data="props.row.cmgroupList"  border style="width: 100%">
							<el-table-column prop="cmgroupName"   label="分组名称">
							</el-table-column>
						</el-table>
				    </template>
				</el-table-column>
				<el-table-column prop="sgvgName"   label="限销策略分组名称">
				</el-table-column>
				<el-table-column prop="sgvgState"   label="状态">
					<template  slot-scope="scope">
						<el-alert v-if="scope.row.sgvgState == 0" title="停用"  type="error"  effect="dark" :closable="false">
						</el-alert>
						<el-alert v-if="scope.row.sgvgState == 1" title="启用"  type="success"  effect="dark" :closable="false">
						</el-alert>
					</template>
				</el-table-column>
				
			</el-table>
		</div>
		<div class="page_content_bottom">
			<el-pagination
				background
				@size-change="setDataPageSize"
				@current-change="setDataPageNumber"
				:current-page="getRequestData.page"
				:page-sizes="[30,50,100,500]"
				:page-size="30"
				layout="total, sizes, prev, pager, next, jumper"
				:total="returnData.total">
			</el-pagination>
		</div>
		
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import restrictionStrategyGroupAction from '@/components/restrictionStrategyGroupAction.vue'
export default {
	//import引入的组件需要注入到对象中才能使用
	components: {
		restrictionStrategyGroupAction,
	},
	data() {
		//这里存放数据
		return {
			
			getRequestData:{
				sgvgName:'',
				page:1,
				rows:30,
				start:'',
				end:'',
			},
			returnData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			buttonList:[],
			selectedDataIndex:0,
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {
	},
	//方法集合
	methods: {

		
		// 动作集合
		actionSet(actionData){
			switch(actionData.actionType){
				case 0:
					this.$refs.restrictionStrategyGroupAction.openBox(0,'')
					break;
				case 1:
					if(this.returnData.list.length<=0){
						this.$message({
							message: '暂无数据',
							type: 'error'
						});
						return false
					}
					var  dataInfo = this.returnData.list[this.selectedDataIndex]
					if(!dataInfo){
						this.$message({
							message: '请先选中要操作的数据',
							type: 'error'
						});
						return false
					}
					var sendData = JSON.parse(JSON.stringify(dataInfo))
					this.$refs.restrictionStrategyGroupAction.openBox(1,sendData)
					break;
				case 2:
					this.delDataAction()
					break;
			}
		},
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1
			this.getDataList()
		},
		// 数据翻页
		setDataPageNumber(val){
			this.getRequestData.page = val
			this.getDataList()
		},
		
		// 切换显示条数
		setDataPageSize(val){
			this.getRequestData.page = 1
			this.getRequestData.rows = val
			this.getDataList()
		},
		
		
		// 获取数据列表
		async getDataList(){
			let responseData =  await this.$http.getRestrictionStrategyGroup(this.getRequestData)
			if(responseData.status == 200){
				this.returnData.list = responseData.result.list
				this.returnData.pages = responseData.result.pages
				this.returnData.total = responseData.result.total
				this.returnData.pageNum = responseData.result.pageNum
				this.selectedDataIndex = 0
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		
		// 删除数据
		delDataAction(){
			if(this.returnData.list.length<=0){
				this.$message({
					message: '暂无数据',
					type: 'error'
				});
				return false
			}
			var  dataInfo = this.returnData.list[this.selectedDataIndex]
			if(!dataInfo){
				this.$message({
					message: '请先选中要操作的数据',
					type: 'error'
				});
				return false
			}
			var sendData = JSON.parse(JSON.stringify(dataInfo))
			this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async()=> {
				var delData = {
					ids:[dataInfo.sgvgId]
				}
				let responseData =  await this.$http.delRestrictionStrategyGroup(delData)
				if(responseData.status == 200){
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
					this.getDataList()
				}else{
					this.$message({
						message: responseData.message,
						type: 'error'
					});
				}
				
			}).catch(() => {});
			
		},
	
		async getButtonList(){
			this.buttonList = await this.$common.getActionButton()
		},
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getDataList()
		this.getButtonList()
		
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() {}, //生命周期 - 创建之前
	beforeMount() {}, //生命周期 - 挂载之前
	beforeUpdate() {}, //生命周期 - 更新之前
	updated() {}, //生命周期 - 更新之后
	beforeDestroy() {}, //生命周期 - 销毁之前
	destroyed() {}, //生命周期 - 销毁完成
	activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
